import { Outlet, useLocation } from "react-router-dom";
import { Heading } from "../design/heading";
import { Navbar, NavbarItem } from "../design/navbar";

const FinancesIndexLayout = () => {
  const { pathname } = useLocation();

  const isCurrent = (slug: string) => {
    if (slug === "")
      return pathname === "/finances" || pathname === "/finances/";
    return pathname.startsWith(`/finances/${slug}`);
  };

  return (
    <div className="space-y-4">
      <Heading>Property & Finances</Heading>
      <Navbar key={"finances-navbar"}>
        <NavbarItem href="" current={isCurrent("")}>
          Summary
        </NavbarItem>
        <NavbarItem href="assets" current={isCurrent("assets")}>
          Assets
        </NavbarItem>
        <NavbarItem href="debts" current={isCurrent("debts")}>
          Debts
        </NavbarItem>
        <NavbarItem
          href="monthly-expense-summaries"
          current={isCurrent("monthly-expense-summaries")}
        >
          Monthly Expenses
        </NavbarItem>
        <NavbarItem href="transactions" current={isCurrent("transactions")}>
          Transactions
        </NavbarItem>
        <NavbarItem href="accounts" current={isCurrent("accounts")}>
          Accounts
        </NavbarItem>
        <NavbarItem href="incomes" current={isCurrent("incomes")}>
          Incomes
        </NavbarItem>
        <NavbarItem
          href="spousal-support"
          current={isCurrent("spousal-support")}
        >
          Spousal Support
        </NavbarItem>
      </Navbar>

      <Outlet />
    </div>
  );
};

export default FinancesIndexLayout;
